// extracted by mini-css-extract-plugin
export default {"collaborator":"Collaborator_collaborator__zMYDe","header":"Collaborator_header__OxWna","imgColaborator":"Collaborator_imgColaborator__QbZcA","footer":"Collaborator_footer__5SyOy"};